// Selectors


import { RootState } from '../../store';

export const credentialTypeSelector = (state: RootState) => state.credentialTypeState
